import { useMemo } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SnowEffect from '../../components/feature/SnowEffect';
import SakuraEffect from '../../components/feature/SakuraEffect';
import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import IntroductionSection from './components/IntroductionSection';
import FeaturesSection from './components/FeaturesSection';
import EventsSection from './components/EventsSection';
import CTASection from './components/CTASection';
import { useSEO, generateOrganizationSchema, generateWebPageSchema } from '../../utils/seo';

const HomePage = () => {
  const currentMonth = useMemo(() => new Date().getMonth() + 1, []);

  const isSakuraSeason = currentMonth >= 3 && currentMonth <= 5;
  const isSnowSeason = currentMonth >= 12 || currentMonth <= 2;

  // SEO設定
  useSEO({
    title: '京都山科 大石神社 | 忠臣蔵ゆかりの神社',
    description: '大石神社は京都市山科区にある歴史ある神社です。御祭神は歌舞伎「仮名手本忠臣蔵」で有名な大石内蔵助。春の大石桜、冬の義士祭など四季折々の魅力をお楽しみいただけます。祈祷予約も承っております。',
    keywords: '大石神社,京都,山科,忠臣蔵,大石内蔵助,義士祭,大石桜,祈祷予約,神社',
    canonical: '/',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        generateOrganizationSchema(),
        generateWebPageSchema('大石神社 | 京都山科の歴史ある神社', '御祭神は忠臣蔵で有名な大石内蔵助。春の大石桜、冬の義士祭など四季折々の魅力', '/')
      ]
    }
  });

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      {isSakuraSeason && <SakuraEffect />}
      {isSnowSeason && <SnowEffect />}
      <Navbar />
      <HeroSection />
      <IntroductionSection />
      <BenefitsSection />
      <FeaturesSection />
      <EventsSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default HomePage;
